import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CONCESSIONS_APPLICATION_TYPE_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { DialogService } from 'dspx-core';

@Component({
  selector: 'app-concessions-application-info',
  templateUrl: './concessions-application-info.component.html',
  styleUrls: ['./concessions-application-info.component.scss']
})
export class ConcessionsApplicationInfoComponent implements OnInit {
  activeDialog: string;
  isExpanded: boolean = true;
  personId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      this.personId = paramMap.get('personId');
    })
  }


  dialogSubmitted($event: any) {

  }

  public startNMWCpplication() {
    this.startApplication(CONCESSIONS_APPLICATION_TYPE_CODES.nonMainsWater);
  }

  public startNMECApplication() {
    this.startApplication(CONCESSIONS_APPLICATION_TYPE_CODES.nonMainsEnergy);
  }

  public startNMMCCApplication() {
    this.startApplication(CONCESSIONS_APPLICATION_TYPE_CODES.nonMainsMedicalCooling);
  }

  public startNMLSCApplication() {
    this.startApplication(CONCESSIONS_APPLICATION_TYPE_CODES.nonMainsLifeSupport);
  }

  public startEDAPOWApplication() {
    this.startApplication(CONCESSIONS_APPLICATION_TYPE_CODES.edapowGoldCardMunicipalRates);
  }

  private startApplication(applicationType: string = null) {
    this.openApplication(applicationType);
  }

  private openApplication(applicationType: string): void {
    switch (applicationType) {
      case CONCESSIONS_APPLICATION_TYPE_CODES.nonMainsWater:
        if (this.personId != null) {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationNonMainsWater.prefix, ROUTE_CONSTANTS.concessionsApplication.forPerson, this.personId]);
        } else {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationNonMainsWater.prefix]);
        }
        break;
      case CONCESSIONS_APPLICATION_TYPE_CODES.nonMainsEnergy:
        if (this.personId != null) {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationNonMainsEnergy.prefix, ROUTE_CONSTANTS.concessionsApplication.forPerson, this.personId]);
        } else {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationNonMainsEnergy.prefix]);
        }
        break;
      case CONCESSIONS_APPLICATION_TYPE_CODES.nonMainsMedicalCooling:
        if (this.personId != null) {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationNonMainsMedicalCooling.prefix, ROUTE_CONSTANTS.concessionsApplication.forPerson, this.personId]);
        } else {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationNonMainsMedicalCooling.prefix]);
        }
        break;
      case CONCESSIONS_APPLICATION_TYPE_CODES.nonMainsLifeSupport:
        if (this.personId != null) {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationNonMainsLifeSupport.prefix, ROUTE_CONSTANTS.concessionsApplication.forPerson, this.personId]);
        } else {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationNonMainsLifeSupport.prefix]);
        }
        break;
      case CONCESSIONS_APPLICATION_TYPE_CODES.edapowGoldCardMunicipalRates:
        if (this.personId != null) {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationEdaAndPowGoldCardMunicipalRates.prefix, ROUTE_CONSTANTS.concessionsApplication.forPerson, this.personId]);
        } else {
          this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationEdaAndPowGoldCardMunicipalRates.prefix]);
        }
        break;
      default:
        this.dialogService.showSimplePopup("This Concession Application Type is not implemented yet", "Ok");
        break;
    }
  }
}
